import { render, staticRenderFns } from "./categories-aside.component.vue?vue&type=template&id=772f111e&scoped=true"
import script from "./categories-aside.component.vue?vue&type=script&lang=ts"
export * from "./categories-aside.component.vue?vue&type=script&lang=ts"
import style0 from "./categories-aside.component.vue?vue&type=style&index=0&id=772f111e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772f111e",
  null
  
)

export default component.exports